import { useInterrogationPaiementsMFO } from '@/hooks';

/**
 * InterrogationPaiementsMFO
 *
 * Déclenche l'interrogation périodique des paiements MFO. Ne rend rien.
 *
 * Doit être monté sous RegisseurContextProvider : il ne tourne alors que lorsqu'un régisseur est
 * connecté, quel que soit l'écran, et n'est pas remonté à chaque changement de page.
 */
const InterrogationPaiementsMFO = () => {
  useInterrogationPaiementsMFO();

  return null;
};

export default InterrogationPaiementsMFO;
